'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fake;

var _jsonSchemaFaker = require('json-schema-faker');

var _jsonSchemaFaker2 = _interopRequireDefault(_jsonSchemaFaker);

var _react = require('react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fakeFunction() {
  var args = Array.prototype.slice.call(arguments);
  console && console.log && console.log("Autogenerated function called with arguments", args); // eslint-disable-line no-console
}

_jsonSchemaFaker2.default.extend('faker', function (faker) {
  faker.type = function (name) {
    switch (name) {
      case 'function':
        return fakeFunction;
      case 'element':
        return (0, _react.createElement)('div', {
          style: { backgroundColor: '#aaa', padding: '1em' }
        }, 'Placeholder');
    }

    return null;
  };

  return faker;
});

function fake(schema) {
  return (0, _jsonSchemaFaker2.default)(schema);
}